/**
 * Maximum character level supported by `level_up_5e`.
 * Raised 3→5 by the level-derived-PB slice to prove the L4→L5 PB boundary.
 * ASI/feat at L4 is silently NOT applied (no ASI logic exists yet) — the
 * deliberate approximation; the real ASI choice surface is a follow-up
 * (tickets/2026-06-21-asi-feat-at-level-4).
 *
 * Zero imports — this file must remain browser-safe.
 */
export const LEVEL_CAP = 5;

/**
 * 5e cumulative XP required to BE a given character level (index = level; index 0
 * unused, level 1 = 0 XP). Full 1–20 table for forward-proofing; `level_up_5e`
 * gates on `xpForLevel(newLevel)` (the gate is capped at LEVEL_CAP regardless).
 * Zero imports — browser-safe, read by both the gate and the level-up UI.
 */
export const XP_THRESHOLDS: readonly number[] = [
  0, 0, 300, 900, 2700, 6500, 14_000, 23_000, 34_000, 48_000, 64_000, 85_000,
  100_000, 120_000, 140_000, 165_000, 195_000, 225_000, 265_000, 305_000,
  355_000,
];

/** Cumulative XP required to reach `level` (0 for out-of-range low, capped high). */
export function xpForLevel(level: number): number {
  if (level <= 1) {
    return 0;
  }
  return XP_THRESHOLDS[Math.min(level, XP_THRESHOLDS.length - 1)] ?? 0;
}
